import { mapGetters, mapState } from 'vuex'
import { DefaultValues, Document, Error } from '@/mixins'
import { debounce, flattenDeep, cloneDeep } from 'lodash'
import moment from 'moment'

const emptyLot = ({
  annex_list: [],
  documents: [],
  exposures: [],
  floor: null,
  furnitures: [],
  lot_type: null,
  lot_subtype: [],
  nb_face: null,
  nature: null,
  pack_list: [],
  parkings: [],
  profitability: null,
  ref: null,
  rent: null,
  capped_rent: null,
  sale_price_ttc: null,
  sale_price_ht: null,
  sales_mode: [],
  status: 'draft',
  surface: null,
  footprint: null,
  buildable_area: null,
  waterproofed_surface: null,
  cadastral_reference: null,
  tax_dispositifs: [],
  intern_visibility: true,
  extern_visibility: true,
  pc_depose_date: null,
  notary_data: {
    name: null,
    phone: null,
    email: null,
    address: null
  },
  created_price_ttc: null
})
const emptyParking = ({
  lot_pk: null,
  nature: null,
  ref: null,
  info: null,
  floor: null,
  sale_price_ht: 0,
  sale_price_ttc: 0,
  parking_type: [],
  sales_mode: [],
  tva: 20
})

export default {
  name: 'LotMixin',
  mixins: [DefaultValues, Document, Error],
  data () {
    return {
      notLoadLotsList: false,
      currentLotPage: 1,
      lotPages: null,
      loadInfiniteLot: false,
      noMoreResult: false,
      noParkingMoreResult: false,
      noAutreMoreResult: false,
      programParkingCount: 0,
      programLotsCount: 0,
      programAutresCount: 0,
      selectedInput: 'ht',
      id: null,
      newLot: false,
      // set to true in the upper component that call this mixin and all children components which embed this Mixin
      isParent: false,
      loading: false,
      loadingOption: true,
      lot: null,
      parking: null,
      lotProgram: null,
      lotDocumentTab: 'LotPlan',
      lotListTab: 'Logement',
      lotOptions: [],
      lotAccesses: [],
      lotDocuments: [],
      lotReservations: [],
      lotsTotal: 0,
      lotPage: 1,
      parkingPage: 1,
      autrePage: 1,
      programLots: [],
      programParkings: [],
      programAutres: [],
      lotVisibility: {
        prescripteur: 0,
        seller: 0
      },
      lotAllotment: 0,
      lotRemuneration: null,
      lotRemunerationLoading: false,
      lotRefAvailable: true,
      parkingRefAvailable: true,
      hasCheck: false,
      submitLoading: false,
      filters: {},
      // set to true for duplicate a lot
      duplicateMode: false,
      // disabled getLotItems
      lotLight: false,
      tvaAmount: null,
      documentsTab: 'DOCUMENTS',
      lotCount: 0,
      getTva: null,
      getHt: null,
      getTtc: null
    }
  },
  computed: {
    ...mapState(['wishlists', 'lastOpenedItemPk', 'currentUser']),
    ...mapGetters(['isAdmin', 'runningOptions', 'isPromoteur', 'isDistributeur', 'canUseBuyerSpace', 'isSeller', 'isManager']),
    l () {
      return this.lot
    },
    pkg () {
      return this.parking
    },
    // return current element (parking or lot), needed for Document Mixin
    documentEl () {
      return this.pkg || this.l
    },
    // return method for patch, needed for Document Mixin
    patchElement () {
      return this.patchLot
    },
    lotPk () {
      if (this.documentEl) {
        return this.documentEl.pk
      } else if (this.$route.params.id) {
        return this.$route.params.id
      } else return null
    },
    lotView () {
      return this.$route.name
    },
    isField () {
      if (this.documentEl) {
        return this.documentEl.nature === 'field'
      } else return null
    },
    isParking () {
      if (this.documentEl) {
        return this.documentEl.nature === 'parking'
      } else return null
    },
    canBeSale () {
      const okStatus = ['available', 'draft']
      return this.isAdmin && this.isPromoteur && okStatus.includes(this.documentEl.status)
    },
    canBeEdited () {
      const koStatus = ['reserved', 'sold']
      return !koStatus.includes(this.documentEl.status) && (this.isAdmin && this.isPromoteur)
    },
    wishlisted () {
      return this.wishlists.find(w => w.pk === this.documentEl.pk)
    },
    canBeOptioned () {
      const okStatus = ['available', 'optioned']
      const koStatus = ['reserved', 'sold']
      if (!this.documentEl || !okStatus.includes(this.documentEl.status)) {
        return false
      }
      if (this.documentEl && !this.documentEl.program.is_optionable) {
        return false
      }
      const programOkStatus = ['available']
      if (!this.lotProgram || !programOkStatus.includes(this.lotProgram.status)) {
        return false
      }
      if (((this.isAdmin || this.isSeller || this.isManager) && !koStatus.includes(this.documentEl.status))) {
        return true
      }
      if (this.documentEl && this.lotProgram) {
        // const verifyOptions = this.runningOptions.filter(x => x.lot === this.documentEl.pk)
        const verifyUser = this.lotOptions.filter(x => x.user.pk === this.currentUser.pk && (x.status === 'approved' || x.status === 'waiting_list'))
        return programOkStatus.includes(this.lotProgram.status) && this.lotProgram.is_optionable && okStatus.includes(this.documentEl.status) && !verifyUser.length
      }
    },
    canBeDenunce () {
      const koStatus = ['sold']
      return !koStatus.includes(this.documentEl.status)
    },
    availableLotStatusList () {
      return Object.values([this.statusData.draft, this.statusData.available]).filter(x => !x.hide)
    },
    salesMode () {
      if (this.isField) return
      if (!this.documentEl.sales_mode) return
      return this.documentEl.sales_mode.map(x => this.salemodeData[x] ? this.salemodeData[x].label : x).join(', ')
    },
    taxDispositifs () {
      if (this.isParking) return
      if (!this.documentEl.tax_dispositifs) return
      return this.documentEl.tax_dispositifs.map(x => this.taxDispositifsData[x] ? this.taxDispositifsData[x].label : x).join(', ')
    },
    brochureDocument () {
      if (this.lotProgram && this.lotProgram.documents && this.lotProgram.documents.length) {
        return this.lotProgram.documents.find(x => x.destination && x.destination.includes('brochure'))
      } else return null
    },
    reservationDocument () {
      if (this.lotProgram && this.lotProgram.documents && this.lotProgram.documents.length) {
        return this.lotProgram.documents.find(x => x.destination && x.destination.includes('contrat_reservation'))
      } else return null
    },
    firstOption () {
      if (!this.loadingOption) {
        return this.lotOptions.find(x => {
          return x.status === 'approved'
        })
      }
    },
    lotReservation () {
      return this.lotReservations[0]
    },
    waitingList () {
      if (!this.loadingOption) {
        return this.lotOptions.filter(x => {
          return x.status === 'waiting_list'
        })
      }
    },
    canceledList () {
      if (!this.loadingOption) {
        return this.lotOptions.filter(x => {
          return x.status === 'canceled' || x.status === 'canceled_auto'
        })
      }
    },
    annexes () {
      let annexes = {}
      if (this.documentEl && this.documentEl.annex_list && this.documentEl.annex_list.length) {
        for (let annex of this.documentEl.annex_list) {
          let annexType = annex.annex_type
          if ((annexType in annexes) === false) {
            annexes[annexType] = { count: 0, surface: [], infos: [] }
          }
          annexes[annexType].count++
          if (annex.surface) annexes[annexType].surface.push(annex.surface)
          if (annex.info) annexes[annexType].infos.push(annex.info)
        }
      }
      return annexes
    },
    parkings () {
      let parkings = {}
      if (this.documentEl && this.documentEl.parkings && this.documentEl.parkings.length) {
        for (let parking of this.documentEl.parkings) {
          let parkingType = parking.parking_type || ''
          if ((parkingType in parkings) === false) {
            parkings[parkingType] = { count: 0, infos: '' }
          }
          parkings[parkingType].count++
          if (parking.info) {
            if (parkings[parkingType].infos.length) {
              parkings[parkingType].infos += `, ${parking.info}`
            } else {
              parkings[parkingType].infos += `${parking.info}`
            }
          }
        }
        let pkgs = {}
        pkgs.type = Object.keys(parkings)
        pkgs.infos = flattenDeep(Object.values(parkings).map(x => x.infos))
        pkgs.count = Object.values(parkings).map(x => x.count)
        pkgs.totalCount = Object.values(parkings).map(x => x.count).reduce((a, b) => {
          return a + b
        }, 0)
        return pkgs
      } else return parkings
    },
    furnitures () {
      let furnitures = {}
      if (this.documentEl && this.documentEl.furnitures && this.documentEl.furnitures.length) {
        for (let furniture of this.documentEl.furnitures) {
          let furnitureType = furniture.ref
          furnitures[furnitureType] = { count: 0, ref: [], info: [] }
          furnitures[furnitureType].count++
          if (furniture.ref) furnitures[furnitureType].ref.push(furniture.ref)
          if (furniture.info) furnitures[furnitureType].info.push(furniture.info)
        }
      }
      return furnitures
    },
    documentsTabs () {
      const docs = [
        {
          label: `TOUS LES DOCUMENTS (${this.allDocumentList.length || 0})`,
          link: 'DOCUMENTS',
          class: 'is-size-6'
        },
        {
          label: `LOT (Visible par les prescripteurs) (${this.lotDocumentList.length || 0})`,
          link: 'LOT',
          class: 'is-size-6'
        },
        {
          label: `DOSSIER DE RÉSERVATION (Annexé au contrat) (${this.dossierReservationDocumentList.length || 0})`,
          link: 'DOSSIER_RESERVATION',
          class: 'is-size-6'
        }
      ]
      if (this.canUseBuyerSpace) {
        docs.push({
          label: `ESPACE ACQUÉREUR (Tous les clients) (${this.espaceAcquereurDocumentList.length || 0})`,
          link: 'ESPACE_ACQUEREUR',
          class: 'is-size-6'
        })
      }
      return docs
    },
    lotDestinations () {
      const destinations = {
        lot: { label: 'Fiche Lot', key: 'lot', enabled: true },
        reservation: { label: 'Dossier de réservation', key: 'reservation', enabled: true },
        buyer_space: { label: 'Espace acquéreur', key: 'buyer_space', enabled: false }
      }
      if (this.canUseBuyerSpace) {
        destinations.buyer_space.enabled = true
      }
      return Object.values(destinations)
    },
    allDocumentList () {
      return this.documentEl.documents
    },
    lotDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('lot')
      })
    },
    dossierReservationDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('reservation')
      })
    },
    espaceAcquereurDocumentList () {
      return this.allDocumentList.filter(x => {
        return x.destination && x.destination.length && x.destination.includes('buyer_space')
      })
    },
    documentsToDisplay () {
      if (this.documentsTab === 'LOT') return this.lotDocumentList
      else if (this.documentsTab === 'DOSSIER_RESERVATION') return this.dossierReservationDocumentList
      else if (this.documentsTab === 'ESPACE_ACQUEREUR') return this.espaceAcquereurDocumentList
      else return this.allDocumentList
    }
  },
  props: {
    sourceLot: Object,
    sourceLotOptions: {
      type: Array,
      default: () => []
    },
    sourceLotDocuments: {
      type: Array,
      default: () => []
    },
    sourceLotAccesses: {
      type: Array,
      default: () => []
    },
    sourceLotReservations: {
      type: Array,
      default: () => []
    },
    sourceLotLots: {
      type: Array,
      default: () => []
    },
    sourceLotProgram: {
      type: Object,
      default: () => {}
    },
    sourceLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    sourceLoading (v) {
      this.loading = v
    },
    '$route.params.id' (to, from) {
      if (to && to !== from && !this.lotLight) {
        this.lotPage = 1
        this.parkingPage = 1
        this.autrePage = 1
        this.programParkingCount = 0
        this.programLotsCount = 0
        this.programAutresCount = 0
        this.programLots = []
        this.programParkings = []
        this.programAutres = []
        this.lotPages = null
        this.currentLotPage = 1
        this.initView()
      }
    }
  },
  created () {
    this.initView()
    if ('check' in this.$route.query) {
      this.hasCheck = true
    }
  },
  methods: {
    initView () {
      if (this.paramsQuickview && this.paramsQuickview.spouseMode) {
        if (this.parkingMode) {
          this.parking = Object.assign({}, this.paramsQuickview.source || cloneDeep(emptyParking))
        } else {
          this.lot = Object.assign({}, this.paramsQuickview.source || cloneDeep(emptyLot))
        }
      } else if (this.sourceLot) {
        this.initLot({ ...this.sourceLot })
      } else if (this.$route.query && this.$route.query.duplicateLot) {
        this.duplicateMode = true
        this.newLot = true
        this.newParking = true
        this.id = this.$route.query.duplicateLot
        this.getLot(this.id)
      } else if (this.$route.params.id) {
        this.id = this.$route.params.id
        this.getLot(this.id)
      } else {
        this.newLot = true
        this.newParking = true
        if (this.parkingMode) {
          this.initLot({ ...cloneDeep(emptyParking) })
        } else {
          this.initLot({ ...cloneDeep(emptyLot) })
        }
      }
      this.updateSources({
        options: this.sourceLotOptions,
        documents: this.sourceLotDocuments,
        reservations: this.sourceLotReservations,
        lots: this.sourceLotLots,
        accesses: this.sourceLotAccesses,
        notes: this.sourceLotNotes,
        program: this.sourceLotProgram
      })
    },
    initLot (item) {
      if (this.parkingMode) {
        this.$set(this, 'parking', item)
      } else {
        this.$set(this, 'lot', item)
      }
      if (this.lot && (!Array.isArray(this.lot.documents) || !this.lot.documents)) this.lot.documents = []
      if (this.lot && (!Array.isArray(this.lot.lot_subtype) || !this.lot.lot_subtype)) this.lot.lot_subtype = []
      if (this.parking && (!Array.isArray(this.parking.documents) || !this.parking.documents)) this.parking.documents = []
      if (this.parking && (!Array.isArray(this.parking.lot_subtype) || !this.parking.lot_subtype)) this.parking.lot_subtype = []
      if (!this.parkingMode && this.initLotForm && typeof this.initLotForm === 'function') {
        this.initLotForm(this.lot)
      }
      if (this.duplicateMode && this.duplicateLotForm && typeof this.duplicateLotForm === 'function') {
        if (this.parkingMode) {
          this.duplicateLotForm(this.parking)
        } else {
          this.duplicateLotForm(this.lot)
        }
      }
      if (!this.lotLight) {
        this.getLotItems()
      }
    },
    beforeSubmitLot (lot) {
      if (!lot.floor_area) lot.floor_area = null
      if (!lot.unbuildable_area) lot.unbuildable_area = null
      if (!lot.footprint) lot.footprint = null
      if (!lot.buildable_area) lot.buildable_area = null
      if (!lot.waterproofed_surface) lot.waterproofed_surface = null
      if (!lot.rent) lot.rent = null
      if (!lot.capped_rent) lot.capped_rent = null
      if (!lot.bonus) lot.bonus = null
      if (lot.building != null) {
        let building = this.lotProgram.buildings.find(x => x.pk === lot.building)
        if (building != null && this.lotProgram.use_tranche) {
          lot.tranche = building.tranche
        }
      }
      if (lot.building == null && lot.tranche !== null) {
        lot.tranche = null
      }
      if (this.lot.tva === null) {
        this.getTva = ((this.lot.sale_price_ttc - this.lot.sale_price_ht) / this.lot.sale_price_ht * 100).toFixed(2)
        this.$set(this.lot, 'tva', this.getTva)
      }
      let newLot = Object.assign({}, lot)
      newLot.force = true
      if (newLot.tax_dispositifs.length) newLot.tax_dispositifs = lot.tax_dispositifs.map(x => x.value)
      if (newLot.sales_mode && newLot.sales_mode.length) {
        newLot.sales_mode = lot.sales_mode.map(x => x.value)
      }
      if (newLot.parkings && newLot.parkings.length) {
        newLot.parkings.forEach(p => {
          if (!p.sales_mode) p.sales_mode = []
          p.sales_mode = p.sales_mode.map(x => x.value)
        })
      }
      if (this.lotProgram && !newLot.program) newLot.program = this.lotProgram.pk
      return newLot
    },
    /**
     * @param { Object } parking
     * @returns { Object } - copy of parking with processed data
     */
    beforeSubmitParking (parking) {
      let newParking = Object.assign({}, parking)
      newParking.force = true
      newParking.nature = 'parking'
      if (this.lotProgram) newParking.program = this.lotProgram.pk
      return newParking
    },
    getLotItems () {
      this.getProgramLotsCount()
      this.getLotProgram()
      if (!this.notLoadLotsList) {
        this.getProgramLots()
        this.getProgramParkings()
        this.getProgramAutres()
      }
      this.getLotOptions()
      this.getLotReservations()
      if (this.isDistributeur || (this.isDistributeur && (this.isSeller || this.currentUser.active_all_contact))) {
        this.getLotRemuneration()
      }
      if (this.isAdmin && this.isPromoteur) {
        this.getLotAccesses()
        this.getLotVisibility()
      }
    },
    updateSources ({ options = null, reservations = null, documents = null, accesses = null, lots = null, program = null, visibility = null }) {
      if (options !== null) {
        this.lotOptions = options
        this.loadingOption = false
      }
      if (reservations !== null) this.lotReservations = reservations
      if (documents !== null) this.lotDocuments = documents
      if (accesses !== null) this.lotAccesses = accesses
      if (lots !== null) this.programLots = lots
      if (program !== null) this.lotProgram = program
      if (visibility !== null) this.lotVisibility = visibility
      if (!this.isParent) {
        this.$emit('updateSources', { options, reservations, documents, accesses, lots, program, visibility })
      }
    },
    /**
     * @param { String } id
     */
    async getLot (id) {
      this.loading = true
      try {
        const { data } = await this.$api.getOne(this.$resources.LOT, id)
        this.initLot(data)
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$router.replace({ name: 'NotFound' })
      }
    },
    /**
     * @param { Object } lot
     */
    async createLot (lot) {
      if (lot.sale_price_ttc) {
        lot.created_price_ttc = lot.sale_price_ttc
      }
      try {
        const { data } = await this.$api.post(this.$resources.LOT, lot)
        this.submitLoading = false
        this.$toasted.global.success('Lot ajouté')
        this.$router.push({ name: 'LotVue', params: { id: data.pk } })
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } lot
     * @param { Boolean } background - for background update, avoid router.push and toast
     */
    async updateLot (lot, background = false) {
      delete lot.parkings
      if (!background) this.submitLoading = true
      if (lot.nature === 'annexe') {
        lot.lot_subtype = []
      }
      try {
        const { data } = await this.$api.put(this.$resources.LOT, this.lotPk, lot)
        if (!background) {
          this.submitLoading = false
          this.$toasted.global.success('Lot modifié')
          if (this.hasCheck) {
            this.$router.goBack()
          } else {
            this.$router.push({ name: 'LotVue', params: { id: data.pk } })
          }
        }
        this.initLot(data)
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } value - small object of edited element to patch
     * @param { Boolean } background - for background update, avoid router.push and toast
     */
    async patchLot (value, background = true) {
      if (!background) this.submitLoading = true
      try {
        const { data } = await this.$api.patch(this.$resources.LOT, this.lotPk, value)
        this.$toasted.global.success('Lot modifié')
        if (!background) {
          this.submitLoading = false
          if (this.hasCheck) {
            this.$router.goBack()
          } else {
            this.$router.push({ name: 'LotVue', params: { id: data.pk } })
          }
          this.initLot(data)
        }
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object, String } lot - full object of only id
     */
    async deleteLot (lot) {
      try {
        const { value } = await this.$swal({
          title: 'Suppression Lot',
          text: 'Le lot ne sera plus consultable, les options qui lui sont liées seront automatiquement annulées.',
          // confirmButtonText: 'Supprimer le lot',
          focusConfirm: false,
          customClass: {
            confirmButton: 'is-danger'
            // cancelButton: 'button is-primary'
          }
        })
        if (value && value.dismiss) return false
        if (value) {
          this.loading = true
          try {
            await this.$api.delete(this.$resources.LOT, lot.pk || lot)
            this.loading = false
            this.$toasted.global.success('Lot supprimé')
            if (this.$route.name === 'LotVue') {
              this.$router.push({ name: 'ProgramVue', params: { id: lot.program.pk } })
            } else if (this.$route.meta.parentName !== 'ProgramVue') {
              this.$router.push({ name: 'LotList' })
            }
            this.$emit('deleteElementInList', lot.pk)
            this.$emit('reload')
          } catch (e) {
            this.loading = false
            this.handleError(e)
          }
        }
      } catch (e) {}
    },
    async getLotReservations () {
      let params = {
        lot: this.lotPk,
        status: ['pre_reserved', 'reserved', 'sold']
      }
      try {
        const { data } = await this.$api.get(this.$resources.RESERVATION, params)
        this.updateSources({ reservations: data.items })
      } catch (e) {
      }
    },
    async getLotOptions () {
      const isInitialLoad = !this.lotOptions || this.lotOptions.length === 0
      if (isInitialLoad) {
        this.loadingOption = true
      }
      let params = {
        lot: this.lotPk,
        sort: 'start_date',
        start_date: moment().format(),
        status: ['waiting_list', 'approved', 'canceled', 'canceled_auto']
      }
      try {
        const { data } = await this.$api.get(this.$resources.OPTION, params)
        this.updateSources({ options: data.items })
      } catch (e) {
        this.loadingOption = false
      }
    },
    async getLotVisibility () {
      try {
        let { data } = await this.$api.get(this.$resources.LOT_VISIBILITY(this.lotPk))
        this.updateSources({ visibility: data })
      } catch (e) {
        console.log(e)
      }
    },
    reloadLotOption (id, option) {
      const i = this.lotOptions.findIndex((o) => {
        return id === o.pk
      })
      if (i >= 0) {
        this.lotOptions.splice(i, 1, option)
        this.$toasted.global.success('L\'option a été mise à jour.')
      }
    },
    async getProgramLotsCount () {
      if (!this.documentEl || !this.documentEl.program) return
      let params = {
        program: this.documentEl.program.pk,
        per_page: 1,
        status: ['available', 'optioned']
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        this.lotCount = data.count
      } catch (e) {
        console.log(e)
      }
    },
    async getProgramLots ($state = null) {
      if (this.filters != null && $state == null) {
        this.currentLotPage = 1
        this.lotPage = 1
      }
      if (this.lotPages && this.currentLotPage >= this.lotPages) return
      this.loadInfiniteLot = true
      this.noMoreResult = false
      let params = {
        program: this.documentEl.program.pk,
        nature: ['lot', 'flat', 'house', 'field', 'commercial', 'office', 'bedroom'],
        page: this.lotPage,
        per_page: 50,
        ...this.filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        if ($state) {
          if (data.items.length) {
            this.programLots.push(...data.items)
            $state.loaded()
          } else {
            if (this.programLots.length > 50) this.noMoreResult = true
            $state.complete()
          }
        } else {
          this.programLots = data.items
        }
        this.lotPages = data.pages
        this.currentLotPage = data.page
        this.programLotsCount = data.count
        if (this.currentLotPage < this.lotPages && !this.noMoreResult) this.lotPage = this.currentLotPage + 1
      } catch (e) {
        console.log(e)
      } finally {
        this.loadInfiniteLot = false
      }
    },
    async getProgramParkings ($state) {
      if (!this.documentEl || !this.documentEl.program) return
      this.loadInfiniteLot = true
      this.noParkingMoreResult = false
      let params = {
        program: this.documentEl.program.pk,
        nature: ['parking'],
        page: this.parkingPage,
        per_page: 50,
        ...this.filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        if ($state) {
          if (data.items.length) {
            this.parkingPage += 1
            this.programParkings.push(...data.items)
            $state.loaded()
          } else {
            if (this.programParkings.length > 50) this.noParkingMoreResult = true
            $state.complete()
          }
        } else {
          this.parkingPage += 1
          this.programParkings = data.items
        }
        this.programParkingCount = data.count
      } catch (e) {
        console.log(e)
      } finally {
        this.loadInfiniteLot = false
      }
    },
    async getProgramAutres ($state) {
      if (!this.documentEl || !this.documentEl.program) return
      this.loadInfiniteLot = true
      this.noAutreMoreResult = false
      let params = {
        program: this.documentEl.program.pk,
        nature: ['garden', 'annexe'],
        page: this.autrePage,
        per_page: 50,
        ...this.filters
      }
      try {
        let { data } = await this.$api.get(this.$resources.LOT, params)
        if ($state) {
          if (data.items.length) {
            this.autrePage += 1
            this.programAutres.push(...data.items)
            $state.loaded()
          } else {
            if (this.programAutres.length > 50) this.noAutreMoreResult = true
            $state.complete()
          }
        } else {
          this.autrePage += 1
          this.programAutres = data.items
        }
        this.programAutresCount = data.count
      } catch (e) {
        console.log(e)
      } finally {
        this.loadInfiniteLot = false
      }
    },
    async getProgram (id) {
      try {
        const { data } = await this.$api.getOne(this.$resources.PROGRAM, id)
        this.updateSources({ program: data })
      } catch (e) {
      }
    },
    async getLotProgram () {
      if (!this.documentEl) return
      let params = {}
      try {
        const { data } = await this.$api.getOne(this.$resources.PROGRAM, this.documentEl.program.pk, params)
        this.updateSources({ program: data })
      } catch (e) {
      }
    },
    async getLotAllotment () {
      let params = { params: this.documentEl.pk }
      try {
        const { data } = await this.$api.get(this.$resources.ALLOTMENT_ALL, params)
        for (let a of data.all_allotment) {
          if (a.accounts) {
            this.lotAllotment += a.accounts.length
          } else if (a.account) {
            this.lotAllotment += 1
          }
        }
      } catch (e) {
      }
    },
    async getLotAccesses () {
      if (!this.documentEl || !this.documentEl.program) return
      let params = { program: this.documentEl.program.pk }
      try {
        let { data } = await this.$api.get(this.$resources.ACCESS, params)
        this.updateSources({ accesses: data.items })
        this.getLotAllotment()
      } catch (e) {
        console.log(e)
      }
    },
    async getLotRemuneration () {
      this.lotRemunerationLoading = true
      if (!this.documentEl) return
      let params = { program: this.documentEl.program.pk }
      try {
        const { data } = await this.$api.get(this.$resources.ACCESS, params)
        this.lotRemuneration = data.items.length ? data.items[0] : null
      } catch (e) {
      }
      if (this.lotRemuneration == null) {
        try {
          let { data } = await this.$api.get(this.$resources.MANDAT, params)
          this.lotRemuneration = data.items && data.items.length ? data.items[0] : null
        } catch (e) {
          console.log(e)
        }
      }
      this.lotRemunerationLoading = false
    },
    /**
     * Check if lot ref is available for this program
     * (can't have duplicate ref for same program)
     * @param { String } val
     */
    verifyAvaibilityLotRef: debounce(async function (val) {
      try {
        const { data } = await this.$api.get(this.$resources.LOT, { ref: val, program: this.lotProgram.pk })
        if ((data.items.length === 1 && data.items[0].pk === this.documentEl.pk) || data.items.length === 0) {
          this.parkingRefAvailable = true
          this.lotRefAvailable = true
        } else {
          this.$toasted.global.danger('La référence existe déjà.')
          this.parkingRefAvailable = false
          this.lotRefAvailable = false
        }
      } catch (e) {
      }
    }, 700),
    async createParking (parking) {
      const newParking = this.beforeSubmitParking(parking)
      try {
        const { data } = await this.$api.post(this.$resources.LOT, newParking)
        this.submitLoading = false
        this.$toasted.global.success('Parking ajouté')
        this.$router.push({ name: 'LotVue', params: { id: data.pk } })
      } catch (e) {
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    /**
     * @param { Object } parking
     * @param { Boolean } background - for background update, avoid router.push and toast
     */
    async updateParking (parking, background = false) {
      if (!background) this.submitLoading = true
      const newParking = this.beforeSubmitParking(parking)
      try {
        const { data } = await this.$api.put(this.$resources.LOT, newParking.pk, newParking)
        if (!background) {
          this.submitLoading = false
          this.$toasted.global.success('Parking modifié')
          if (this.hasCheck) {
            this.$router.goBack()
          } else {
            this.$router.push({ name: 'LotVue', params: { id: data.pk } })
          }
        }
      } catch (e) {
        console.log(e)
        this.submitLoading = false
        this.$toasted.global.danger('Erreur lors de l\'enregistrement !')
      }
    },
    async addToWishlist () {
      try {
        let { data } = await this.$api.post(this.$resources.WISHLIST, { lots: [this.documentEl.pk] })
        this.$store.commit('setWishlist', { wishlists: data })
        this.$toasted.global.success('Ajouté aux favoris.')
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de l\'ajout aux favoris')
      }
    },
    async deleteFromWishlist (id = null) {
      try {
        let { data } = await this.$api.removeFromWishlist([id != null ? id : this.documentEl.pk])
        this.$store.commit('setWishlist', { wishlists: data })
        this.$toasted.global.success('Supprimé de la liste des favoris')
        this.$emit('deleteFromWishlist')
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la suppression du favoris')
      }
    },
    /**
    * update sale price ttc
    * @param {number} valSalePrice
    */
    updateSalePrice (valSalePrice) {
      let salePriceTTC, salePriceHT
      if (this.documentEl.tva === null) {
        this.documentEl.sale_price_ttc = Number(valSalePrice)
        return this.documentEl.sale_price_ttc
      } else {
        let salePriceTTC, salePriceHT
        if (!this.documentEl.sale_price_ttc || Number(valSalePrice) !== Number(this.documentEl.sale_price_ttc)) {
          salePriceTTC = valSalePrice
          salePriceHT = salePriceTTC / (1 + (this.documentEl.tva / 100))
          salePriceHT = salePriceHT.toFixed(2)
          this.documentEl.sale_price_ht = Number(salePriceHT)
          this.documentEl.sale_price_ttc = Number(salePriceTTC)
          this.tvaAmount = salePriceTTC - salePriceHT
        }
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    },
    /**
    * update sale price ht
    * @param {number} valSalePriceHt
    */
    async updateSalePriceHt (valSalePriceHt) {
      let salePriceTTC, salePriceHT
      if (this.documentEl.tva === null) {
        this.documentEl.sale_price_ht = Number(valSalePriceHt)
        return this.documentEl.sale_price_ht
      } else {
        if (!this.documentEl.sale_price_ht || Number(valSalePriceHt) !== Number(this.documentEl.sale_price_ht)) {
          salePriceHT = valSalePriceHt
          salePriceTTC = salePriceHT * (1 + (this.documentEl.tva / 100))
          salePriceTTC = salePriceTTC.toFixed(2)
          this.documentEl.sale_price_ttc = Number(salePriceTTC)
          this.documentEl.sale_price_ht = Number(salePriceHT)
          this.tvaAmount = salePriceTTC - salePriceHT
        }
      }
      this.updatePrice(salePriceTTC, salePriceHT)
    },
    updateTva (val) {
      let salePriceTTC, salePriceHT
      salePriceTTC = Number(this.documentEl.sale_price_ttc)
      salePriceHT = Number(this.documentEl.sale_price_ht)
      if (val !== 'autre') {
        if (val) this.$set(this.documentEl, 'tva', val)
        let tva = this.documentEl.tva
        salePriceTTC = salePriceHT * (1 + (tva / 100))
        salePriceTTC = salePriceTTC.toFixed(2)
      } else if (val === 'autre') {
        this.$set(this.documentEl, 'tva', null)
      }
      if (salePriceTTC === 'NaN') salePriceTTC = null
      if (salePriceHT === 'NaN') salePriceHT = null
      this.updatePrice(salePriceTTC, salePriceHT)
    },
    updatePrice (salePriceTTC, salePriceHT) {
      if (salePriceTTC) this.$set(this.documentEl, 'sale_price_ttc', salePriceTTC)
      if (salePriceHT) this.$set(this.documentEl, 'sale_price_ht', salePriceHT)
      this.$set(this, 'tvaAmount', Number(this.documentEl.sale_price_ttc) - Number(this.documentEl.sale_price_ht))
    },
    roundedValue (value) {
      if (isNaN(value)) {
        return 0
      } else {
        return Math.round(value * 100) / 100
      }
    }
  }
}
